import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { read, write, utils, WorkBook, WorkSheet, writeFile } from 'xlsx';
import { LookupService } from 'projects/shared/core/services/lookup.service';
import { ToastService } from 'projects/shared/core/services/toast.service';
import { PatientUploadService } from "../shared/services/patient.upload.service";
import { DatetimeService } from "../../shared/services/datetime.service";
import { UserManagementService } from "../../shared/core-jpats/services/user-management.service";
import { LoadingSpinnerService } from 'ndms/app/shared/core-ui/loading-spinner/loading-spinner.service';
import * as moment from 'moment';

@Component({
  selector: 'fileupload',
  templateUrl: './fileupload.component.html',
  styleUrls: ['./fileupload.component.scss']
})
export class FileuploadComponent implements OnInit {
  @ViewChild('inputFile') inputFile: ElementRef;

  message: string="";
  results: any[]= [];
  instructionCols: any[] = [
    { field: 'External_Identifier', header: 'External_Identifier', width:'10%', desc: 'An existing wristband or barcode value for the patient. Leaving this field blank will auto-generate a JPATS ID for the patient.' },
    { field: 'First_Name', header: 'First_Name', width:'7%', desc:'Required. The first name of the patient.' },
    { field: 'Last_Name', header: 'Last_Name', width:'7%',desc:'Required. The last name of the patient.' },
    { field: 'Sex_Key', header: 'Sex_Key', width:'5%',desc: 'Required. The key code for the sex. This value can be found by downloading lookups.' },
    { field: 'DOB', header: 'DOB', width:'5%',desc:'Required. Must be in a valid date format. Example: 01/12/1977.' },
    { field: 'Unaccompanied_Minor', header: 'Unaccompanied_Minor', width:'10%', desc:'A value of yes or no indicating the minor status of the patient.' },
    { field: 'CCATT', header: 'CCATT', width:'5%',desc:'A value of yes or no indicating the Critical Care Air Transport team status of the patient.' },
    { field: 'Originating_Facility', header: 'Originating_Facility', width:'10%',desc:'The originating facility name.' },
    { field: 'Patient_Type_Key', header: 'Patient_Type_Key', width:'10%', desc:'Required. The key code for patient type. This value can be found by downloading lookups.' },
    { field: 'Health_Status_Key', header: 'Health_Status_Key', width:'5%', desc:'Required. The key code for health status. This value can be found by downloading lookups.' },
    { field: 'Bed_Type_Key', header: 'Bed_Type_Key', width:'10%', desc:'Required. The key code for bed type. This value can be found by downloading lookups.' },
    { field: 'Injury_Nature', header: 'Injury_Nature', width:'7%', desc:'A description of any patient injuries.' },
    { field: 'Notes', header: 'Notes', width:'7%', desc:'Any notes related to the patient.' }
  ];
  cols: any[] = [];
  expectedCols: any[];
  constructor(
    private lookupService: LookupService,
    private _title: Title,
    private patientUploadService: PatientUploadService, 
    private dateTimeService: DatetimeService,
    private toastService: ToastService,
    private userManagementService: UserManagementService,
    private loadingSpinnerService: LoadingSpinnerService) { }
  patientTypes: any[]= [];
  healthStatus: any[] =[];
  bedTypes:any[] = [];
  genders: any[] = [];
  instructions:boolean = false;
  readErrors: number = 0;

  currentFcc = null;
  currentLocation = null;
  currentOperation = null;
  get canEdit() {
    return !!(this.currentFcc?.active && this.currentLocation?.active && this.currentOperation?.active);
  }

  ngOnInit() {
    this._title.setTitle("Import/Export Patient Patients - JPATS");
    this.patientTypes = this.lookupService.get("PatientTypes") || [];
    this.healthStatus =this.lookupService.get("PatientHealthStatuses")|| [];
    this.bedTypes =this.lookupService.get("PatientBedTypes")|| [];
    this.genders = this.lookupService.get("Genders") || [];

    let bpb = document.querySelector('[bypass-block]');
    if (bpb instanceof HTMLElement) {
      bpb.focus();
      bpb.blur();
    }

    this.userManagementService.getCurrentUser().subscribe((userData) => {
      if (userData.fcc) this.currentFcc = userData.fcc;
      if (userData.location) this.currentLocation = userData.location;
      if (userData.operation) this.currentOperation = userData.operation;
    });
  }

  arrayBuffer:any;
  file:File;
  filetoupload: any;

  incomingfile(event)
  {
    this.file= event.target.files[0];
  }

  setFileUpload() {

  }

  showInstructions(){
    this.instructions= !this.instructions;
  }

  upload(){
    let patients = this.filetoupload.map((patient)=>{
      return {
        name: {firstName:patient.First_Name,lastName:patient.Last_Name},
        isUnaccompaniedMinor: patient.Unaccompanied_Minor === 'Yes',
        driversLicenseNumber: null,
        age: patient.DOB ? (moment().diff(moment(patient.DOB), 'years')) : null,
        ageQualifier: patient.DOB ? 'Years' : null,
        notes:null,
        socialSecurityNumber:"",
        nationality:null,patientHealthStatus:null,
        injuryNatureDescription:null,
        patientBedType:null,
        patientType:null,
        identifierType:null,
        patientKey:null,
        key:null,
        encodedImage:null,
        identifiers:[],
        patientMedicalDetailsModel:{
          patientType: this.patientTypes.find(i => i.key === patient.Patient_Type_Key),
          patientBedType: this.bedTypes.find(i => i.key === patient.Bed_Type_Key),
          patientHealthStatus: this.healthStatus.find(i => i.key === patient.Health_Status_Key),
          injuryNatureDescription: patient.Injury_Nature,
          notes: patient.Notes,
        },
        gender: this.genders.find(i => i.key === patient.Sex_Key),
        birthDate:this.dateTimeService.formatUploadDate(patient.DOB),
        patientIdentifierModel: {identifierNumber:patient.External_Identifier}

      };
    });

    this.loadingSpinnerService.show("Importing...");
    this.patientUploadService.uploadPatients(patients).subscribe((res)=>{
      //this.message = "<div class='alert-success'>Success</div>"
      this.toastService.showSuccess("Patient Upload Successful!");
      this.filetoupload = undefined;
      this.inputFile.nativeElement.value = '';
      this.arrayBuffer = undefined;
      this.file = undefined;
      this.results = [];
      this.cols = [];
      
      setTimeout(() => this.loadingSpinnerService.hide());
    });
  }

  downloadLookups(){
    this.exportAsExcelFile(this.filetoupload, "lookups.xlsx")
  }

  exampleFile(){
    this.exportAsImportTemplateFile("import_template.xlsx");
  }

  exportAsExcelFile(json: any[], excelFileName: string): void {
    const workbook: WorkBook = {
      Sheets: {
        'Patient Types': utils.json_to_sheet(this.patientTypes),
        'Health Statuses':utils.json_to_sheet(this.healthStatus),
        'Bed Types':utils.json_to_sheet(this.bedTypes),
        'Sexes' : utils.json_to_sheet(this.genders)
      },
      SheetNames: ['Patient Types','Health Statuses','Bed Types','Sexes'] };
    writeFile(workbook, excelFileName);
  }

  exportAsImportTemplateFile( excelFileName: string): void {
    let example ={};
    this.instructionCols.forEach((col, index)=>{
      example[col.field] = '';
    });
    const workbook: WorkBook = {
      Sheets: {
        'Import Template': utils.json_to_sheet([example]),
      },
      SheetNames: ['Import Template'] };
    writeFile(workbook, excelFileName);
  }

  readFile(){
    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.readErrors = 0;
      this.arrayBuffer = fileReader.result;
      let data = new Uint8Array(this.arrayBuffer);
      let arr = new Array();
      for(let i = 0; i != data.length; ++i)
        arr[i] = String.fromCharCode(data[i]);

      let bstr = arr.join("");
      let workbook = read(bstr, {type:"binary",cellDates:true, cellNF: false, cellText:false});
      let first_sheet_name = workbook.SheetNames[0];
      let worksheet = workbook.Sheets[first_sheet_name];
      this.filetoupload =utils.sheet_to_json(worksheet,{raw:false,dateNF:"MM/DD/YYYY"});
      this.results = this.filetoupload.map((patient)=>{
        console.log("patient", patient);
        let patientType = this.patientTypes.find(i => i.key === patient.Patient_Type_Key);
        let patientBedType = this.bedTypes.find(i => i.key === patient.Bed_Type_Key);
        let patientHealthStatus= this.healthStatus.find(i => i.key === patient.Health_Status_Key);
        let gender = this.genders.find(i => i.key === patient.Sex_Key);

        if (!patient.First_Name) {
          this.readErrors++;
        }
        if (!patient.Last_Name) {
          this.readErrors++;
        }
        if (!(patient.Sex_Key && gender)) {
          this.readErrors++;
        }
        if (!this.dateTimeService.validDate(patient.DOB)) {
          this.readErrors++;
        }
        if (!(patient.Patient_Type_Key && patientType)) {
          this.readErrors++;
        }
        if (!(patient.Health_Status_Key && patientHealthStatus)) {
          this.readErrors++;
        }
        if (!(patient.Bed_Type_Key && patientBedType)) {
          this.readErrors++;
        }

        return {
          External_Identifier: patient.External_Identifier || "Auto Generated",
          First_Name: patient.First_Name ?
          `<span class='alert-success'>${patient.First_Name}</span>` : `<span class='alert-danger'>${patient.First_Name} :Invalid</span>`,
          Last_Name: patient.Last_Name ?
          `<span class='alert-success'>${patient.Last_Name}</span>` : `<span class='alert-danger'>${patient.Last_Name} :Invalid</span>`,
          Sex_Key: patient.Sex_Key && gender ?
            `<span class='alert-success'>${patient.Sex_Key}</span>` : `<span class='alert-danger'>${patient.Sex_Key} :Invalid</span>`,
          DOB: this.dateTimeService.validDate(patient.DOB) ?
            `<span class='alert-success'>${patient.DOB}</span>` : `<span class='alert-danger'>${patient.DOB} :Invalid</span>`,
          Unaccompanied_Minor: patient.Unaccompanied_Minor,
          CCATT: patient.CCATT,
          Originating_Facility: patient.Originating_Facility,
          Patient_Type_Key: patient.Patient_Type_Key && patientType ?
            `<span class='alert-success'>${patient.Patient_Type_Key}</span>` : `<span class='alert-danger'>${patient.Patient_Type_Key} :Invalid</span>`,
          Health_Status_Key: patient.Health_Status_Key && patientHealthStatus ?
            `<span class='alert-success'>${patient.Health_Status_Key}</span>` : `<span class='alert-danger'>${patient.Health_Status_Key} :Invalid</span>`,
          Bed_Type_Key: patient.Bed_Type_Key && patientBedType ?
            `<span class='alert-success'>${patient.Bed_Type_Key}</span>` : `<span class='alert-danger'>${patient.Bed_Type_Key} :Invalid</span>`,
          Injury_Nature: patient.Injury_Nature,
          Notes: patient.Notes
        };
      });
      this.cols = [];

      let objcols = this.get_header_row(worksheet);

      this.instructionCols.forEach((col)=>{
        let ncol = Object.assign({},col,{htmlClass: objcols.find(i => col.field === i) ? "" :"alert-danger"});
        this.cols.push(ncol);
      });
      objcols.forEach((col)=>{
        if(!this.cols.find((i) => i.field === col))
          this.cols.push({ field: col, htmlClass:'alert-danger', header: col});
      });
      /*this.cols = Object.keys(this.results[0]).map((res)=>{
        return { field: res, header: res };
      });*/
      console.log(this.filetoupload);
    };
    fileReader.readAsArrayBuffer(this.file);
  }

  get_header_row(sheet) {
    let headers:any[] = [];
    let range = utils.decode_range(sheet['!ref']);
    let C, R = range.s.r; /* start in the first row */
    /* walk every column in the range */
    for(C = range.s.c; C <= range.e.c; ++C) {
      let cell = sheet[utils.encode_cell({c:C, r:R})] /* find the cell in the first row */
      let hdr = "UNKNOWN " + (C || ""); // <-- replace with your desired default
      if(cell && cell.t) hdr = utils.format_cell(cell) || "";
      headers.push(hdr);
    }
    return headers;
  }

  onMainContentClick() {
    let mc = document.querySelector('[main-content]');
    if (mc instanceof HTMLElement) {
      mc.focus();
      mc.blur();
    }
  }
}
